<script type="ts">
  import { Line } from "svelte-chartjs";
  import { store, gameState } from "../../store.js";

  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale,
  } from "chart.js";

  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale
  );

  $: game = $store.find((g) => g.id == $gameState.currentGame);

  const getPointStyle = (index: number) => {
    // no rounds played yet
    if (game.rounds == 0) {
      return null;
    }

    // winning player
    if (index === 0) {
      // create image to display as point style for winning player
      const img = new Image();
      img.src = "/crown.png";
      img.width = 20;
      img.height = 20;
      // change z-index to make sure image is displayed on top of other points
      img.style.zIndex = "100";

      const pointStyles = Array(game.rounds);
      // replace last value of array with image
      pointStyles[game.rounds - 1] = img;
      return pointStyles;
    } else {
      // other players
      return null;
    }
  };

  $: data = {
    labels: Array.from(Array(game.rounds).keys()),
    datasets: game.players.map((player, index) => {
      return {
        label: player.name,
        data: player.statsPoints,
        borderColor: player.color,
        pointStyle: getPointStyle(index),
      };
    }),
  };
</script>

<Line
  {data}
  options={{
    layout: {
      padding: {
        left: 0,
        right: 10,
        top: 0,
        bottom: 0,
      },
    },
    clip: false,
  }}
/>
